import { FoundationProject } from '@models';
import { MutationPayload } from './mutation-payload';

export interface UpdateProjectEssentialsResult {
  updateProjectEssentials: UpdateFoundationProjectPayload;
}

export interface UpdateFoundationProjectPayload extends MutationPayload {
  project?: FoundationProject;
}
